/**
 * Loads Swiper only when a slider is in viewport (or when ensureSwiperLoaded is called).
 * Reduces TBT by not parsing/executing the bundle until needed.
 */
(function () {
  var url = window.swiperBundleUrl;
  if (!url) return;

  var loading = false;
  var loaded = false;
  var queue = [];

  function runQueue() {
    loaded = true;
    queue.forEach(function (cb) { cb(); });
    queue = [];
    document.dispatchEvent(new CustomEvent('swiper-loaded'));
  }

  function loadScript() {
    if (typeof window.Swiper !== 'undefined') {
      loaded = true;
      runQueue();
      return;
    }
    if (loaded || loading) return;
    loading = true;

    var s = document.createElement('script');
    s.src = url;
    s.async = false;
    s.defer = true;
    s.onload = function () {
      loading = false;
      runQueue();
    };
    s.onerror = function () {
      loading = false;
    };
    document.head.appendChild(s);
  }

  window.ensureSwiperLoaded = function (cb) {
    if (typeof cb !== 'function') return;
    if (typeof window.Swiper !== 'undefined') {
      cb();
      return;
    }
    queue.push(cb);
    loadScript();
  };

  var selectors = '.hero-slider, .video_reviews__container, .related_product__list, .drawer__progress_products, .product-spotlight-v2';
  var elements = document.querySelectorAll(selectors);
  if (elements.length === 0) return;

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          loadScript();
          observer.disconnect();
          return;
        }
      }
    },
    { rootMargin: '100px', threshold: 0 }
  );

  elements.forEach(function (el) { observer.observe(el); });
})();
